import CircularProgress from "@mui/material/CircularProgress";

export default function PingLoader() {
    return (
        <div
            className="flex justify-center items-center w-full h-full bg-cover"
            style={{ backgroundImage: "url(/images/auth-bg.jpg)" }}
        >
            <CircularProgress size="6rem" thickness={3.8} />
        </div>
    );
}
